const BASE_URL =
  process.env['RAILS_ENV'] === 'production'
    ? 'https://open-door-c13.herokuapp.com'
    : 'http://localhost:3000';
// const BASE_URL = 'https://open-door-c13.herokuapp.com';

const CSRFToken = () =>
  document.querySelector('meta[name="csrf-token"]').content;

const parseJSON = async (resp) => {
  const body = await resp.json();

  if (resp.ok) {
    return body;
  } else {
    throw Error(body);
  }
};

export default {
  submitAnswer: (audioRecording, assignmentId) => {
    return fetch(BASE_URL + `/p/assignment/${assignmentId}`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': CSRFToken(),
      },
      body: audioRecording,
    }).then(parseJSON);
  },
  sendCompletionEmail: (assignmentId) => {
    fetch(BASE_URL + `/p/assignment/complete/${assignmentId}`)
  },
  assignmentViewed: (assignmentId) => {
    return fetch(BASE_URL + `/p/assignment/viewed/${assignmentId}`)
  }
};
